import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Is this book about finding a partner?',
    answer: "No. It's about finding YOURSELF and building your security. Interestingly, when you're a secure and autonomous woman, you attract better relationships — but our focus is your current peace of mind."
  }, {
    question: "What if I don't have much time?",
    answer: 'The protocol is designed to be consumed in 15 minutes a day. These are tactical steps you can apply while having your morning coffee.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-24" data-id="element-34">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-37">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-cream-warm rounded-lg overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-cream-warm/30 hover:bg-cream-warm/50 transition-colors" data-id="element-40">
                <span className="text-lg font-bold text-navy-900 pr-4" data-id="element-41">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>

              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="p-6 bg-white text-navy-800 leading-relaxed border-t border-cream-warm" data-id="element-45">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}